import Aplicacion from './components/Aplicacion';
import './styles/tailwind.css';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Tiquetera from './components/Tiquetera';
import Financiera from './components/Financiera';
import SistPersonalizado from './components/SistPersonalizado';
import Rgsesiones from './components/Rgsesiones';
import Rgturnos from './components/Rgturnos';
import Rgstock from './components/Rgstock';

function App() {
  return (
    <>
    <Router>
      <Routes>
        <Route path="/" element={<Aplicacion />} />
        <Route path="/productos/tiquetera" element={<Tiquetera></Tiquetera>} />
        <Route path="/productos/financiera" element={<Financiera></Financiera>} />
        <Route path="/productos/personalizados" element={<SistPersonalizado></SistPersonalizado>} />
        <Route path="/productos/rgsesiones" element={<Rgsesiones></Rgsesiones>} />
        <Route path="/productos/rgturnos" element={<Rgturnos></Rgturnos>} />
        <Route path="/productos/rgstock" element={<Rgstock></Rgstock>} />
      </Routes>
    </Router>
    </>
  );
}

export default App;
